import React from "react";
import { Box, Button, Grid2, Stack, Typography } from "@mui/material";
import DateInput from "../../../../../components/common/input/DateInput";
import TextInput from "../../../../../components/common/input/TextInput";
import { numeralCustom } from "../../../../../utils/helpers";

function InfoSection() {
  return (
    <Stack gap={2} sx={{ p: 1 }}>
      {/* Điểm đón */}
      <Stack
        gap={0.5}
        sx={{
          p: 1,
          borderRadius: "10px",
          border: "1px dashed",
          borderColor: "divider",
        }}
      >
        <Typography sx={{ fontWeight: 600 }}>Điểm đón</Typography>
        <Stack direction="row" alignItems="center" gap={1}>
          <Button
            size="small"
            sx={{
              textTransform: "none",
              color: "text.primary",
              backgroundColor: "background.default",
              "&:hover": {
                backgroundColor: "background.default",
              },
            }}
          >
            <Typography>
              VPHVT{" "}
              <Typography
                component="span"
                sx={{
                  fontWeight: 600,
                  fontSize: "primary.main",
                  color: "primary.main",
                }}
              >
                9:00
              </Typography>{" "}
            </Typography>
          </Button>
          <Button
            size="small"
            sx={{
              textTransform: "none",
              color: "text.primary",
              backgroundColor: "background.default",
              "&:hover": {
                backgroundColor: "background.default",
              },
            }}
          >
            <Typography>
              VPTD{" "}
              <Typography
                component="span"
                sx={{
                  fontWeight: 600,
                  fontSize: "primary.main",
                  color: "primary.main",
                }}
              >
                10:00
              </Typography>{" "}
            </Typography>
          </Button>
        </Stack>
      </Stack>
      {/* Thông tin */}
      <Box
        sx={{
          p: 1,
          borderRadius: "10px",
          border: "1px dashed",
          borderColor: "divider",
        }}
      >
        <Grid2 container spacing={2}>
          <Grid2 size={{ xs: 6 }}>
            <Stack gap={1}>
              <DateInput label="Ngày đi" labelWidth="30%" />
              <TextInput label="Di động" labelWidth="30%" />
              <DateInput label="Ngày sinh" labelWidth="30%" />
              <TextInput label="Đón" labelWidth="30%" />
              <TextInput label="Trả" labelWidth="30%" />
              <TextInput
                disabled
                required
                label="Phòng đôi 2 khách"
                labelWidth="30%"
                value={numeralCustom(75000).format()}
                endAdornment="VND"
              />
              <TextInput
                label="Coupon"
                labelWidth="30%"
                value={numeralCustom(0).format()}
              />
              <TextInput label="Ghi chú" minRows={3} labelWidth="30%" />
              <TextInput label="Email" labelWidth="30%" />
            </Stack>
          </Grid2>
          <Grid2 size={{ xs: 6 }}>
            <Stack gap={1}>
              <TextInput label="Giờ" labelWidth="30%" />
              <TextInput label="Tên" labelWidth="30%" />
              <TextInput label="TC" labelWidth="30%" />
              <TextInput label="TC trả" labelWidth="30%" />
              <TextInput label="Giảm giá" labelWidth="30%" />
              <TextInput label="Mã giảm giá" labelWidth="30%" />
              <TextInput label="Phụ thu" labelWidth="30%" />
              <TextInput label="Chọn đại lý" labelWidth="30%" />
              <TextInput label="Mã" labelWidth="30%" />
            </Stack>
          </Grid2>
        </Grid2>
      </Box>
    </Stack>
  );
}

export default InfoSection;
